import React, {Component} from "react";
import {View, FlatList, ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import AdapterListMyApplyOperation from "./adapters/AdapterListMyApplyOperation";
import store from "../../../../redux/store";
import HMButton from "../../../../customviews/HMButton";

let container = null;
export default class ListMyApplyOperationScreen extends Component {
    constructor(props) {
        super(props);
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 800 ? 2 : 1;

        }
        this.state = {

            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,

            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: ''
        };
        container = this;

        this.props.callserviceActionRefresh();
    }

    state = {
        show: false
    };

    componentWillReceiveProps(props) {

    }

    componentWillMount() {
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 800 ? 2 : 1,
                    },
                )


            })

        this.props.callserviceActionRefresh()


        this.getData(1)
        //  this.props.callServiceAddFirst(this.props.route.params.result, this.props.item_count);
    }

    async getData(page) {
        let {data, item} = this.props.route.params;
        console.log("data", data,item);
        ///data = data ? JSON.parse(data) : data;
        let after = "0000-00-00";
        //   this.props.callService(urlListMyApplyOperationScreen, `?type=${this.props.typee}&city=`, TypeGetListMyApplyOperationScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListMyApplyOperationScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListMyApplyOperationScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListMyApplyOperationScreen, _GET, page, 10)
  */

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": "GetTickets",
            "typepm": data.typepm,
            "lang": i18n.locale,
            "token": store.getState().reducerSplashGetAllData.token,
            // "token": "Basic MDkxODk1NjEwMDk6MTIzNDU2Nw==",
            "page": page,
            //"token_fb": this.props.DataSplashScreen.token_fb,
        };
        if (store.getState().reducerSplashGetAllData.Connection) {

            // this.props.callService(this.props.route.params.item.link_url, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListMyApplyOperationScreen, _GET, page, typeExport._Count, this.props.route.params.item.id)
            //  this.props.callService(typeExport.urlListMyApplyOperationScreen, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListMyApplyOperationScreen, _GET, page, typeExport._Count, null)
            this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetListMyApplyOperationScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(`List${this.props.route.params.item.id}`)
            // let data = await AsyngStorageClass.getASyng(global.IdCity  +typeExport.ListMyApplyOperation+ item.type)
            // //this.props.callServiceSuccess(data, 0)
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))
            store.dispatch(serviceActionError("offline"))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    render() {
        let {item, data} = this.props.route.params
        // let {ListNotSendMyApplyOperation} = store.getState().reducerSplashGetAllData
        //
        // ListNotSendMyApplyOperation = ListNotSendMyApplyOperation.sort(function (a, b) {
        //     if (a.index > b.index) {
        //         return -1;
        //     }
        //     if (a.index < b.index) {
        //         return 1;
        //     }
        //     return 0;
        // });

        return (
            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar

                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListMyApplyOperation.title')}
                            //text={i18n.t('ListNews.title')}
                            text={(data.name ? data.name : (data.title ? data.title : ''))}

                            back
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        {/*<TouchableOpacity
                            onPress={()=>{
                                store.dispatch(serviceActionAddSubList([{
                                    address:"aaaa",
                                    code: "_",
                                    color: "#ff0000",
                                    comment: [],
                                    createdtime: "19/8/8",
                                    image:null,
                                    video: null,
                                    latitude: '43.56564',
                                    longitude: "34.37546",
                                    status: i18n.t('constant.registrated'),
                                    title: "aaabbbb",
                                    subjectid: "111"
                                }, ...store.getState().reducerListMyApplyOperationScreen.results]))
                            }}
                            style={{width:'100%',height:moderateScale(40)}}
                        />*/}
                        <View style={{flex: 1}}>
                            {/*{*/}
                            {/*ListNotSendMyApplyOperation.length === 0 ?*/}
                            {/*null*/}
                            {/*:*/}
                            {/*<TouchableOpacity*/}
                            {/*onPress={() => {*/}

                            {/*this.setState({visibleModal: 'ModalListNotSend'})*/}

                            {/*}}*/}
                            {/*style={{*/}
                            {/*width: "100%",*/}
                            {/*height: moderateScale(38),*/}
                            {/*paddingHorizontal: moderateScale(10),*/}
                            {/*backgroundColor: Colors.white,*/}
                            {/*marginBottom: moderateScale(6)*/}
                            {/*}}>*/}
                            {/*<View*/}

                            {/*style={{*/}
                            {/*//  width: typeExport.WIDTH - moderateScale(40),*/}
                            {/*width: "100%",*/}

                            {/*height: moderateScale(38),*/}
                            {/*alignSelf: 'center',*/}
                            {/*// backgroundColor: 'blue',*/}
                            {/*flexDirection: 'row',*/}
                            {/*alignItems: 'center'*/}
                            {/*}}*/}
                            {/*onPress={*/}
                            {/*// () => {*/}
                            {/*// }*/}
                            {/*this.showMenu*/}
                            {/*}*/}
                            {/*>*/}
                            {/*<View style={{flexDirection: 'row', flex: .85}}>*/}
                            {/*<HMTextView*/}
                            {/*noFont={false}*/}
                            {/*text={"*پیام های ارسال نشده*"}*/}
                            {/*numberOfLines={1}*/}
                            {/*style={{*/}
                            {/*fontSize: moderateScale(12),*/}
                            {/*textAlign: 'right',*/}
                            {/*color: Colors.blackLight*/}
                            {/*}}/>*/}
                            {/*</View>*/}


                            {/*<View style={{flex: .10}}>*/}
                            {/*<View style={{*/}
                            {/*position: 'relative',*/}
                            {/*height: moderateScale(34),*/}
                            {/*width: moderateScale(34)*/}
                            {/*}}>*/}
                            {/*<Icon name="ios-mail" style={{*/}
                            {/*color: Colors.red,*/}
                            {/*fontSize: moderateScale(28),*/}
                            {/*padding: moderateScale(4),*/}
                            {/*alignSelf: "center",*/}
                            {/*}}/>*/}
                            {/*{*/}
                            {/*ListNotSendMyApplyOperation.length === 0 ? null :*/}
                            {/*<HMTextView text={ListNotSendMyApplyOperation.length} styleRoot={{*/}
                            {/*position: 'absolute',*/}
                            {/*overflow: 'hidden',*/}
                            {/*top: 0,*/}
                            {/*right: 0,*/}
                            {/*}} style={{*/}

                            {/*paddingLeft: ListNotSendMyApplyOperation.length < 10 ? moderateScale(6) : moderateScale(3),*/}
                            {/*paddingRight: ListNotSendMyApplyOperation.length < 10 ? moderateScale(6) : moderateScale(3),*/}
                            {/*borderRadius: moderateScale(10),*/}
                            {/*backgroundColor: Colors.colorSecondPrimary,*/}
                            {/*alignSelf: 'flex-end',*/}
                            {/*fontSize: moderateScale(10),*/}
                            {/*color: Colors.white*/}
                            {/*}}/>*/}
                            {/*}*/}
                            {/*</View>*/}
                            {/*/!**/}
                            {/*<Icon name={"md-arrow-dropdown"} style={{fontSize: moderateScale(22)}}/>*/}
                            {/**!/*/}
                            {/*</View>*/}
                            {/*</View>*/}
                            {/*/!*  <Menu*/}
                            {/*ref={this.setMenuRef}*/}
                            {/*style={{}}*/}
                            {/*button={*/}
                            {/*<TouchableOpacity*/}

                            {/*style={{*/}
                            {/*//  width: typeExport.WIDTH - moderateScale(40),*/}
                            {/*width: "100%",*/}

                            {/*height: moderateScale(38),*/}
                            {/*alignSelf: 'center',*/}
                            {/*// backgroundColor: 'blue',*/}
                            {/*flexDirection: 'row',*/}
                            {/*alignItems: 'center'*/}
                            {/*}}*/}
                            {/*onPress={*/}
                            {/*// () => {*/}
                            {/*// }*/}
                            {/*this.showMenu*/}
                            {/*}*/}
                            {/*>*/}
                            {/*<View style={{flexDirection: 'row', flex: .9}}>*/}
                            {/*<HMTextView*/}
                            {/*noFont={false}*/}
                            {/*text={this.state.textMenu}*/}
                            {/*numberOfLines={1}*/}
                            {/*style={{*/}
                            {/*fontSize: moderateScale(12),*/}
                            {/*textAlign: 'right',*/}
                            {/*color: Colors.blackLight*/}
                            {/*}}/>*/}
                            {/*</View>*/}


                            {/*<View style={{flex: .1}}>*/}
                            {/*<Icon name={"md-arrow-dropdown"} style={{fontSize: moderateScale(22)}}/>*/}
                            {/*</View>*/}
                            {/*</TouchableOpacity>*/}

                            {/*//*/}
                            {/*//          <TouchableOpacity*/}
                            {/*//              style={{*/}
                            {/*//                  textAlign: 'center',*/}
                            {/*//*/}
                            {/*//                  width: moderateScale(24),*/}
                            {/*//                  height: moderateScale(24),*/}
                            {/*//*/}
                            {/*//              }}*/}
                            {/*//              onPress={this.showMenu}>*/}
                            {/*//*/}
                            {/*//              <Icon name="md-more"*/}
                            {/*//                    style={{*/}
                            {/*//                        fontSize: moderateScale(24),*/}
                            {/*//                        color: Colors.white,*/}
                            {/*//                        textAlign: 'center'*/}
                            {/*//                    }}/>*/}
                            {/*//          </TouchableOpacity>*/}
                            {/*//*/}
                            {/*//*/}

                            {/*}*/}
                            {/*>*/}
                            {/*{*/}
                            {/*typeExport.ListMenu_ListMyApplyOperation.map((item, key) => {*/}
                            {/*return (<HMMenuItem item={item} key={key} hideMenu={this.hideMenu}/>) //if you have a bunch of keys value pair*/}

                            {/*})*/}

                            {/*}*/}
                            {/*</Menu>*!/*/}
                            {/*</TouchableOpacity>*/}
                            {/*}*/}


                            <EmptyView empty={this.props.empty}/>
                            <FlatList
                                data={this.props.results}
                                renderItem={this.renderItem}
                                keyExtractor={(item, index) => index.toString()}
                                ListEmptyComponent={() =>
                                    null}
                                //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}

                                numColumns={this.state.columnCount}
                                key={this.state.columnCount}
                            />
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }


                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderItem = ({item, index}) => {
        return <AdapterListMyApplyOperation item={item} item_parent={this.props.route.params.item}
                                            index={index} hiddenModal={this.hiddenModal}/>;
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashGetAllData.Connection) {
            this.getData(1)
        } else {
            //  ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListMyApplyOperationScreen, `?type=${this.props.typee}&city=`, TypeGetListMyApplyOperationScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {

        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashGetAllData.Connection) {
            // this.props.callService(urlListMyApplyOperationScreen, `?type=${this.props.typee}&city=`, TypeGetListMyApplyOperationScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }
}
